import { DB_PREFIX } from './constants';

export default {
  [DB_PREFIX]: {
    drivingLicenseURL: '',
    passportURL: '',
    euIDCardURL: '',
  },
};
